import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import ColorPicker from './ColorPicker';

const RECENT_KEY = 'recentConfigColors';
const RECENT_MAX = 20;

const getRecentColors = () => {
  try {
    const arr = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    if (Array.isArray(arr)) return arr;
  } catch {}
  return [];
};
const saveRecentColors = (arr) => {
  localStorage.setItem(RECENT_KEY, JSON.stringify(arr));
};

const ColorPickerModal = ({ isOpen, toggle, value, onChange, label }) => {
  const [selectedColor, setSelectedColor] = useState(value);
  const [recentColors, setRecentColors] = useState([]);

  useEffect(() => {
    setRecentColors(getRecentColors());
  }, [isOpen]);

  const handleSave = () => {
    // Update recent colors
    let arr = recentColors.filter(c => c !== selectedColor);
    arr.unshift(selectedColor);
    if (arr.length > RECENT_MAX) arr = arr.slice(0, RECENT_MAX);
    setRecentColors(arr);
    saveRecentColors(arr);
    onChange(selectedColor);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered style={{ minWidth: 300 }}>
      <ModalHeader toggle={toggle}>{label || 'Select Color'}</ModalHeader>
      <ModalBody>
        <div className="d-flex flex-column gap-3" style={{alignItems: 'center'}}>
          <ColorPicker
            value={selectedColor}
            onChange={setSelectedColor}
            recentColors={recentColors}
          />
          <div className="d-flex justify-content-end gap-2">
            <Button color="secondary" onClick={toggle}>Cancel</Button>
            <Button color="primary" onClick={handleSave}>Save</Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ColorPickerModal; 